import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import { documentPreviewEndpoint, fetchDocumentObjectUrl } from '../../utils/documentDownload';

const FALLBACK =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RnG4W+FgYxN';

interface DocumentAuthImageProps {
  documentId: number;
  fileType?: string | null;
  alt?: string;
  style?: React.CSSProperties;
  height?: number | string;
}

const DocumentAuthImage: React.FC<DocumentAuthImageProps> = ({
  documentId,
  fileType,
  alt,
  style,
  height = 150,
}) => {
  const [src, setSrc] = useState<string>('');

  useEffect(() => {
    let active = true;
    let revoke: (() => void) | undefined;

    void fetchDocumentObjectUrl(documentId, documentPreviewEndpoint(fileType))
      .then((result) => {
        if (!active) {
          result.revoke();
          return;
        }
        revoke = result.revoke;
        setSrc(result.url);
      })
      .catch(() => {
        if (active) setSrc('');
      });

    return () => {
      active = false;
      revoke?.();
    };
  }, [documentId, fileType]);

  return (
    <Image
      alt={alt || 'Документ'}
      src={src || FALLBACK}
      style={{ height, objectFit: 'cover', ...style }}
      fallback={FALLBACK}
      preview={src ? { src } : false}
    />
  );
};

export default DocumentAuthImage;
